import React, { useState, useEffect } from 'react';
import MachineManager from './MachineManager';
import AccountMaps from './AccountMaps';
import Accounts from './Accounts';
import AccountSettings from './AccountSettings';
import './MachineHeader.css';
import { useSearchParams } from 'react-router-dom';

// Deep-link tab keys used by the left nav (DJB-107).
// DJB-130: the standalone Detail view is gone — its containers render inline
// on Overview, so old ?tab=details / ?view=details&id links degrade to
// the list tab (MachineManager preselects the linked account from ?id).
// DJB-208: the Settings sub-page hosts the fleet-wide settings sections.
// DJB-239: the Maps sub-page sits between Overview and Manager.
const TAB_FROM_PARAM = {
  list: 'machineManager',
  details: 'machineManager',
  maps: 'maps',
  accounts: 'accounts',
  settings: 'settings',
};

const MachineHeader = () => {
  const [searchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState('machineManager');

  useEffect(() => {
    const tab = searchParams.get('tab');
    const view = searchParams.get('view');
    const id = searchParams.get('id');
    if (TAB_FROM_PARAM[tab]) {
      setActiveTab(TAB_FROM_PARAM[tab]);
    } else if (view === 'details' && id) {
      setActiveTab('machineManager');
    }
  }, [searchParams]);

  // DJB-191: no .machine-header-container / .tab-content-machine wrappers —
  // the active tab's container (.machine-manager-container / .accounts-page)
  // sits directly in the page content. The tab buttons stay for the ?tab=
  // deep links but are hidden by CSS (DJB-120/125).
  return (
    <>
      <div className="tab-buttons">
        <button
          className={`tab ${activeTab === 'machineManager' ? 'active' : ''}`}
          onClick={() => setActiveTab('machineManager')}
        >
          {/* DJB-129: renamed from "List view"; DJB-211: from "Accounts Info" */}
          Overview
        </button>
        <button
          className={`tab ${activeTab === 'maps' ? 'active' : ''}`}
          onClick={() => setActiveTab('maps')}
        >
          {/* DJB-239: Maps sub-page shell; the map itself is DJB-240 */}
          Maps
        </button>
        <button
          className={`tab ${activeTab === 'accounts' ? 'active' : ''}`}
          onClick={() => setActiveTab('accounts')}
        >
          {/* DJB-110: renamed from "Accounts"; DJB-211: from "Accounts Manager" */}
          Manager
        </button>
        <button
          className={`tab ${activeTab === 'settings' ? 'active' : ''}`}
          onClick={() => setActiveTab('settings')}
        >
          {/* DJB-208: fleet-wide settings sub-page */}
          Settings
        </button>
      </div>
      {activeTab === 'machineManager' && <MachineManager />}
      {activeTab === 'maps' && <AccountMaps />}
      {activeTab === 'accounts' && <Accounts />}
      {activeTab === 'settings' && <AccountSettings />}
    </>
  );
};

export default MachineHeader;
